import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Haendler } from '../../stammdaten/haendler/haendler';
import { Tierliste } from '../../gruppe-tier/classes/tierliste';
import { GruppeTier } from '../../gruppe-tier/classes/gruppe-tier';

export class AbgangslisteReload {
    tierliste: Tierliste;
    reloadAbgangsliste: boolean; // tab 3
    reloadGruppenTiere: boolean; // tab 1
    /** When true, tier-eingabe keeps browse-list mode (alle/teil) after add; scan input is cleared separately. */
    preserveEingabe: boolean;
    /** Optional; legacy hint when an animal was removed from the Ausstallliste. */
    removedTier?: GruppeTier;

    constructor(
        tierliste: Tierliste,
        reloadAbgangsliste: boolean,
        reloadGruppenTiere: boolean,
        preserveEingabe = false,
        removedTier?: GruppeTier,
    ) {
        this.tierliste = tierliste;
        this.reloadAbgangsliste = reloadAbgangsliste;
        this.reloadGruppenTiere = reloadGruppenTiere;
        this.preserveEingabe = preserveEingabe;
        this.removedTier = removedTier;
    }
}

@Injectable({ providedIn: 'root' })
export class GruppeAbgangService {
    abgangSubject = new Subject<number>();
    abgaenge = 0;

    abgangdatum: Date;
    ausstallgewicht: number;

    abnehmerSubject: Subject<Haendler> = new Subject<Haendler>();
    abnehmer: Haendler;
    abgangslisteSubject = new Subject<AbgangslisteReload>();
    alleTiereHinzugefuegtSubject = new Subject<boolean>();

    tierListeAbgeschlossenSubject = new Subject<Tierliste>();
    gruppeAktualisierenSubject = new Subject<number>(); // gruppe_id für Aktualisierung
    private scanHistoryByTierliste = new Map<number, Array<{ ohrmarke: string; success: boolean }>>();

    constructor() {}

    private _tierliste: Tierliste;

    get tierliste(): Tierliste {
        return this._tierliste;
    }

    set tierliste(value: Tierliste) {
        this._tierliste = value;
    }

    private _abteilAbgang: string;

    get abteilAbgang(): string {
        return this._abteilAbgang;
    }

    set abteilAbgang(value: string) {
        this._abteilAbgang = value;
    }

    watchAlleTiereHinzugefuegt(): Observable<boolean> {
        return this.alleTiereHinzugefuegtSubject.asObservable();
    }

    setAbgangsliste(
        tierliste: Tierliste,
        reloadAbgangsliste: boolean,
        reloadGruppenTiere: boolean,
        preserveEingabe = false,
        removedTier?: GruppeTier,
    ) {
        this.tierliste = tierliste;
        const obj = new AbgangslisteReload(
            tierliste,
            reloadAbgangsliste,
            reloadGruppenTiere,
            preserveEingabe,
            removedTier,
        );
        this.abgangslisteSubject.next(obj);
    }

    watchAbgangsliste(): Observable<AbgangslisteReload> {
        return this.abgangslisteSubject.asObservable();
    }

    public watchAbnehmer() {
        return this.abnehmerSubject.asObservable();
    }

    public tierListeAbgeschlossen(tierListe: Tierliste, sender: string) {
        console.log('tierListeAbgeschlossen: ', sender);
        this.tierListeAbgeschlossenSubject.next(tierListe);
    }

    public watchTierListeAbgeschlossen() {
        return this.tierListeAbgeschlossenSubject.asObservable();
    }

    public gruppeAktualisieren(gruppe_id: number) {
        this.gruppeAktualisierenSubject.next(gruppe_id);
    }

    public watchGruppeAktualisieren() {
        return this.gruppeAktualisierenSubject.asObservable();
    }

    getScanHistory(tierlisteId: number): Array<{ ohrmarke: string; success: boolean }> {
        const id = Number(tierlisteId || 0);
        if (id <= 0) {
            return [];
        }
        const history = this.scanHistoryByTierliste.get(id) || [];
        return history.map(item => ({ ...item }));
    }

    pushScanHistory(tierlisteId: number, ohrmarke: string, success: boolean): void {
        const id = Number(tierlisteId || 0);
        const normalizedOhrmarke = String(ohrmarke || '').trim();
        if (id <= 0 || !normalizedOhrmarke) {
            return;
        }
        const history = this.getScanHistory(id);
        history.unshift({ ohrmarke: normalizedOhrmarke, success: !!success });
        this.setScanHistory(id, history);
    }

    setScanHistory(tierlisteId: number, history: Array<{ ohrmarke: string; success: boolean }>): void {
        const id = Number(tierlisteId || 0);
        if (id <= 0) {
            return;
        }
        const normalized = (history || [])
            .map(item => ({
                ohrmarke: String(item?.ohrmarke || ''),
                success: !!item?.success,
            }))
            .filter(item => item.ohrmarke.length > 0)
            .slice(0, 20);
        this.scanHistoryByTierliste.set(id, normalized);
    }
}
